<script lang="ts" setup>
const { pageHeaderMenu } = usePageHeaderMenu()
</script>
<template>
  <div>
    <a
      href="#main-content"
      class="skip-link"
    >
      Preskočiť na hlavný obsah
    </a>
    <Header />
    <main
      id="main-content"
      class="w-100"
      :class="{ 'has-page-header-menu': pageHeaderMenu.show }"
    >
      <slot />
    </main>
    <ClientOnly>
      <LazyFooter />
    </ClientOnly>
    <div id="modal-wrap" />
  </div>
</template>
